import i18n from 'services/base/i18n';

export default {
  title: (domain: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malicious Domain', 'Blocked malicious domain (%1$s) for %2$s.'),
    domain, device,
  ),

  description: (domain: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malicious Domain', 'Traffic to/from a listed malicious domain (%1$s) has been blocked by Pangolin from communicating with %2$s.'),
    domain, device,
  ),

  kindTitle:        () => i18n.pgettext('Issues|Malicious Domain|Kind', 'Malicious Domain Access'),
  kindSubtitle:     () => i18n.pgettext('Issues|Malicious Domain|Kind', 'Phishing / Malvertising / Hacked Sites'),

  actionValueAllow: () => i18n.pgettext('Issues|Malicious Domain|Action', 'Allow'),
  actionValueBlock: () => i18n.pgettext('Issues|Malicious Domain|Action', 'Block'),

  actionLabelAllow: () => i18n.pgettext('Issues|Malicious Domain|Action', 'Allow traffic between host and domain'),
  actionLabelBlock: () => i18n.pgettext('Issues|Malicious Domain|Action', 'Block traffic between host and domain'),
};
